import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ShieldCheck } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../../../ui/card';
import { payrollAPI } from '../../../../services/api';

const ReadOnlyRow = ({ label, value }) => (
  <div className="flex justify-between items-center py-2 border-b last:border-b-0">
    <span className="text-sm text-muted-foreground">{label}</span>
    <span className="font-medium tabular-nums">{value}</span>
  </div>
);

const QatarPayrollForm = () => {
  const { t } = useTranslation();
  const [rates, setRates] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    payrollAPI.getStatutoryRates('QA')
      .then(setRates)
      .catch(() => setRates(null))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="flex justify-center py-12"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary" /></div>;
  if (!rates) return <p className="text-sm text-muted-foreground py-8 text-center">{t('payrollGulf.qaUnavailable')}</p>;

  const c = rates.contributions;
  const e = rates.eosb;

  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-semibold">🇶🇦 {t('payrollGulf.qaTitle')}</h3>
        <p className="text-sm text-muted-foreground">
          QPSA — {t('payrollGulf.readOnlyNote')}
        </p>
      </div>

      <div className="rounded-md border border-emerald-200 bg-emerald-50 px-4 py-2 text-xs text-emerald-800 dark:border-emerald-900 dark:bg-emerald-950 dark:text-emerald-200 flex items-center gap-2">
        <ShieldCheck className="h-4 w-4 shrink-0" />
        {t('payrollGulf.certifiedBadge', { version: rates.config_version })}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Card>
          <CardHeader className="pb-3">
            <CardTitle className="text-base">{t('payrollGulf.qaQpsaCard')}</CardTitle>
          </CardHeader>
          <CardContent className="space-y-1">
            <ReadOnlyRow label={t('payrollGulf.empShare')} value={`${(c.employee_rate * 100).toFixed(2)} %`} />
            <ReadOnlyRow label={t('payrollGulf.employerShare')} value={`${(c.employer_rate * 100).toFixed(2)} %`} />
            <ReadOnlyRow label={t('payrollGulf.baseCap')} value={`${c.base_cap.toLocaleString()} ${rates.currency}`} />
            <p className="text-xs text-muted-foreground pt-2">{c.base_note}. {t('payrollGulf.qaExpatNote')}</p>
          </CardContent>
        </Card>

        <Card>
          <CardHeader className="pb-3">
            <CardTitle className="text-base">{t('payrollGulf.eosbCard')}</CardTitle>
          </CardHeader>
          <CardContent className="space-y-1">
            <ReadOnlyRow label={t('payrollGulf.rightPerYear')} value={`${e.days_per_year} ${t('payrollGulf.daysUnit')}`} />
            <ReadOnlyRow label={t('payrollGulf.minSeniority')} value={`${e.min_years} ${t('payrollGulf.yearUnit')}`} />
            <p className="text-xs text-muted-foreground pt-2">{e.base_note}. {t('payrollGulf.qaProvisioned')}</p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default QatarPayrollForm;
